import { useState } from 'react';

export type PageSize = 10 | 25 | 50 | 100;

export const PAGE_SIZE_OPTIONS: PageSize[] = [10, 25, 50, 100];

// Isti obrazac pamćenja kao odabrani jezik/sklopljeni izbornik (localStorage) —
// jedan zajednički ključ znači da promjena na bilo kojoj list-stranici vrijedi
// odmah i za sve ostale.
const PAGE_SIZE_KEY = 'externo_list_page_size';

const readStoredPageSize = (): PageSize => {
  const stored = Number(localStorage.getItem(PAGE_SIZE_KEY));
  return PAGE_SIZE_OPTIONS.includes(stored as PageSize) ? (stored as PageSize) : 10;
};

export const usePageSize = (): [PageSize, (next: PageSize) => void] => {
  const [pageSize, setPageSizeState] = useState<PageSize>(readStoredPageSize);

  const setPageSize = (next: PageSize) => {
    localStorage.setItem(PAGE_SIZE_KEY, String(next));
    setPageSizeState(next);
  };

  return [pageSize, setPageSize];
};
